import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { spacingClassNamePropType } from '../../__utils/spacingClassNamePropType';

const Environment = ({ children, env, className, qaId }) => {
  const envClasses = classNames({
    [`uni-env--${env}`]: env,
    [className]: className,
  });

  return (
    <section className={envClasses} data-qa-id={qaId}>
      {children}
    </section>
  );
};

Environment.propTypes = {
  env: PropTypes.oneOf(['light', 'dark']),
  children: PropTypes.node,
  className: spacingClassNamePropType,
  qaId: PropTypes.string,
};

Environment.defaultProps = {
  className: '',
};

export default Environment;



// WEBPACK FOOTER //
// ./src/theme/environment/index.jsx